<template>
  <div class="trainingWheels community-cal-container">
    <CommunityCalendar
      :reservations="[]"
    />
  </div>
</template>

<script>
import axios from 'axios';
import CommunityCalendar from '../../common/CommunityCalendar/CommunityCalendar';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'OrgCalendarIndex'.toLowerCase(),
  components: { CommunityCalendar },
  props: {
    organizationjson: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    communityView: null,
    splitDays: [],
  }),
  computed: {
    ...mapState({
      organization: state => state.organization,
    }),
  },
  created() {
    this.setCurrentOrganization({
      organization: JSON.parse(this.organizationjson),
    });
    this.getCommunityView();
  },
  methods: {

    async getCommunityView() {
      const { data: {
        organization: communityView,
      } } = await axios.get(`/api/${ this.organization.slug }/community/calendar`);
      this.communityView = communityView;
      for (const court of communityView.courts) {
        this.splitDays.push({
          id: court.id,
          label: court.name,
        });
      }
    },

    ...mapActions([
      'setCurrentOrganization',
    ]),
  },
};
</script>

<style scoped>
  .trainingWheels {
    border-style: solid;
  }
  .community-cal-container {
    display: flex;
    justify-content: center;
  }
</style>